import { VueConstructor } from 'vue';
import { HighlightsButtonAction } from '@front-app/modules/group/highlights/model';
// Link-only buttons
import LinkExternalButton from './LinkExternalButton.vue';
import DownloadPdfExternalButton from './DownloadPdfExternalButton.vue';
import ReferColleagueToGroupButton from './ReferColleagueToGroupButton.vue';
import SubmitSuggestionButton from './SubmitSuggestionButton.vue';
import StartQuizButton from './StartQuizButton.vue';
// Complex buttons
import ViewExternalVideoButton from './ViewExternalVideoButton.vue';
import MessageUserButton from './MessageUserButton.vue';
import DownloadPdfInternalButton from './DownloadPdfInternalButton.vue';
import ContentSearchButton from './ContentSearchButton.vue';
import ViewEventButton from './ViewEventButton.vue';

export const BUTTON_BY_ACTION: Record<HighlightsButtonAction, VueConstructor> = {
	[HighlightsButtonAction.DOWNLOAD_FILE_EXTERNAL]: DownloadPdfExternalButton as VueConstructor,
	[HighlightsButtonAction.DOWNLOAD_FILE_INTERNAL]: DownloadPdfInternalButton as VueConstructor,
	[HighlightsButtonAction.LINK_EXTERNAL]: LinkExternalButton as VueConstructor,
	[HighlightsButtonAction.MESSAGE_USER]: MessageUserButton as VueConstructor,
	[HighlightsButtonAction.REFER_COLLEAGUE_TO_GROUP]: ReferColleagueToGroupButton as VueConstructor,
	[HighlightsButtonAction.START_QUIZ]: StartQuizButton as VueConstructor,
	[HighlightsButtonAction.SUBMIT_SUGGESTION]: SubmitSuggestionButton as VueConstructor,
	[HighlightsButtonAction.VIEW_EXTERNAL_VIDEO]: ViewExternalVideoButton as VueConstructor,
	[HighlightsButtonAction.CONTENT_SEARCH]: ContentSearchButton,
	[HighlightsButtonAction.VIEW_EVENT]: ViewEventButton,
};
